"use client";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./AdminConfirmationModal.css";

export default function AdminConfirmationModal({ message, onClose }) {
  const { t } = useTranslation();

  const reason = String(message || "").replace(/^❌\s*/, "").trim();
  const prefix = t("questions.moderation.refused.prefix");

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const onBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose?.();
  };

  return (
    <div
      className="admin-modal-backdrop"
      role="dialog"
      aria-modal="true"
      onClick={onBackdropClick}
    >
      <div className="admin-modal-card" role="document" aria-live="polite">
        <button
          className="admin-modal-close"
          type="button"
          aria-label={t("questions.common.close")}
          onClick={onClose}
        >
          ×
        </button>

        <div className="admin-modal-icon" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18" stroke="#D92B2B" strokeWidth="1.2" strokeLinecap="square" strokeLinejoin="round" />
            <path d="M6 6L18 18" stroke="#D92B2B" strokeWidth="1.2" strokeLinecap="square" strokeLinejoin="round" />
          </svg>
        </div>

        <h3 className="admin-modal-title">{t("questions.moderation.refused.title")}</h3>

        <p className="admin-modal-text">
          {prefix}&nbsp;
          <span className="admin-modal-reason">
            {reason || t("questions.moderation.refused.unknownReason")}
          </span>
        </p>

        <button className="admin-modal-btn" type="button" onClick={onClose}>
          {t("questions.common.done")}
        </button>
      </div>
    </div>
  );
}
